import './styles.scss';

interface LiveBadgeProps {
	type?: 'eventCard';
}

const LiveBadge = ({ type = 'eventCard' }: LiveBadgeProps) => <div className={`liveBadge liveBadge--${type}`}>Live</div>;

export default LiveBadge;
